import { render, staticRenderFns } from "./IndemnityModalStep2.vue?vue&type=template&id=d161183c&scoped=true"
import script from "./IndemnityModalStep2.vue?vue&type=script&lang=js"
export * from "./IndemnityModalStep2.vue?vue&type=script&lang=js"
import style0 from "./IndemnityModalStep2.vue?vue&type=style&index=0&id=d161183c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d161183c",
  null
  
)

export default component.exports